<template>
  <v-navigation-drawer
    :value="isAddEditSidebarActive"
    temporary
    touchless
    :right="true"
    :width="$vuetify.breakpoint.smAndUp ? 450 : '100%'"
    app
    @input="(val) => $emit('update:is-add-edit-sidebar-active', val)"
  >
    <v-card height="100%">
      <div class="drawer-header d-flex align-center mb-4">
        <span class="font-weight-semibold text-base text--primary">{{ isEditMode ? 'Actualizar' : 'Agregar' }}</span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          small
          @click="$emit('update:is-add-edit-sidebar-active',false)"
        >
          <v-icon size="22">
            {{ icons.mdiClose }}
          </v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent="onSubmit"
        >
          <!-- #### Source ############## -->
          <v-text-field
            v-model="itemData.source"
            outlined
            dense
            :rules="[validators.validateRequired]"
            :counter="15"
            label="Source"
            placeholder="Source"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### SourceId ############## -->
          <v-text-field
            v-model="itemData.sourceId"
            outlined
            dense
            :rules="[validators.validateRequired]"
            label="Source Id"
            placeholder="Source Id"
            hide-details="auto"
            type="number"
            class="mb-6"
          ></v-text-field>

          <!-- #### Value ############## -->
          <v-textarea
            v-model="itemData.value"
            outlined
            dense
            :rules="[validators.validateRequired]"
            :counter="5000"
            label="Valor"
            placeholder="Valor"
            hide-details="auto"
            class="mb-6"
          ></v-textarea>

          <!-- #### CreatedOn ############## -->
          <v-text-field
            v-model="itemData.createdOn"
            outlined
            dense
            :rules="[validators.validateRequired]"
            :counter="8"
            label="Creado En"
            placeholder="Creado En"
            hide-details="auto"
            class="mb-6"
          ></v-text-field>

          <!-- #### UserId ############## -->
          <v-text-field
            v-model="itemData.userId"
            outlined
            dense
            :rules="[validators.validateRequired]"
            label="Id De Usuario"
            placeholder="Id De Usuario"
            hide-details="auto"
            type="number"
            class="mb-6"
          ></v-text-field>

          <!-- #### Active ############## -->
          <v-switch
            v-model="itemData.active"
            inset
            :label="`${itemData.active ? 'Activo' : 'Inactivo'}`"
          ></v-switch>

          <v-btn
            :color="isEditMode ? 'info' : 'primary'"
            class="me-3"
            type="submit"
          >
            {{ isEditMode ? 'Actualizar' : 'Agregar' }}
          </v-btn>
          <v-btn
            color="secondary"
            outlined
            type="reset"
            @click="resetItemData"
          >
            Cancelar
          </v-btn>
        </v-form>
      </v-card-text>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import { mdiClose, mdiEyeOutline, mdiEyeOffOutline } from '@mdi/js'
import { ref } from '@vue/composition-api'
import { validateRequired } from '@core/utils/validation'
import store from '@/store'

export default {
  model: {
    prop: 'isAddEditSidebarActive',
    event: 'update:is-add-edit-sidebar-active',
  },
  props: {
    isAddEditSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit }) {
    const isEditMode = ref(false)

    const blankItemData = {
      source: null,
      sourceId: null,
      value: null,
      createdOn: null,
      active: false,
    }

    const valid = ref(false)
    const form = ref(null)

    const validate = () => {
      form.value.validate()
    }

    const resetForm = () => {
      form.value.reset()
    }

    const itemData = ref(JSON.parse(JSON.stringify(blankItemData)))

    const resetItemData = () => {
      itemData.value = JSON.parse(JSON.stringify(blankItemData))
      resetForm()
      emit('update:is-add-edit-sidebar-active', false)
      isEditMode.value = false
    }

    const onSubmit = () => {
      if (valid.value) {
        let mode = 'Insert'
        if (isEditMode.value === true) {
          mode = 'Update'
        }
        store.dispatch('notes/apiCall', { mode, request: itemData.value }).then(result => {
          if (result.success) {
            emit('refetch-data')
            emit('update:is-add-edit-sidebar-active', false)
            resetItemData()
          }
        })
      } else {
        validate()
      }
    }

    const ShowEditDialog = key => {
      store.dispatch('notes/apiCall', { mode: 'Select', request: { key } }).then(result => {
        if (result.success) {
          itemData.value = result.data
          emit('update:is-add-edit-sidebar-active', true)
          isEditMode.value = true
        }
      })
    }

    return {
      isEditMode,
      resetItemData,
      form,
      onSubmit,
      itemData,
      valid,
      validate,
      ShowEditDialog,

      // validation
      validators: { validateRequired },
      icons: {
        mdiClose,
        mdiEyeOutline,
        mdiEyeOffOutline,
      },
    }
  },
}
</script>
